import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';

import { Title } from '@xsolla/ui-core';
import { AlertExclamationColorful } from '@xsolla/ui-icons';

import { ApiError } from '../../../api/types';
import { useConfig } from '../../../contexts/config';
import { ErrorDescriptionWrapper, ErrorWrapper } from './styles';

type Props = {
  error: ApiError | null;
};

const AttributesErrorMessage = ({ error }: Props): JSX.Element => {
  const intl = useIntl();
  const { xsollaAnalytics } = useConfig();

  useEffect(() => {
    xsollaAnalytics.sendOpen('login_pa_module__user-attributes_open', 'error', {
      error: error?.description || ''
    });
  }, []);

  return (
    <ErrorWrapper>
      <AlertExclamationColorful size={48} />

      <Title center indent="sm">
        {intl.formatMessage({ id: 'app.error.000-000' })}
      </Title>

      <ErrorDescriptionWrapper>{error?.description}</ErrorDescriptionWrapper>
    </ErrorWrapper>
  );
};

export default AttributesErrorMessage;
